import json from './sprite.js';

export default {
    handle: 'SP_SPS4-Pants',
    label: 'es_SPS4-Pants_234684089',
    json,
};
